module.exports = __webpack_public_path__ + "img/nav-01.9dce2f37.jpg";